import { createFileRoute, redirect } from '@tanstack/react-router'
import PageResetPassword from '@/pages/account/reset-password'

export const Route = createFileRoute('/app/account/reset-password/$token')({
  beforeLoad: ({ location }) => {
    // Handle legacy path redirect
    if (location.pathname.includes('/resetpassword/')) {
      const token = location.pathname.split('/resetpassword/')[1]
      throw redirect({
        to: `/app/account/reset-password/$token`,
        params: { token: token },
      })
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <PageResetPassword />
}
